import { storage } from '../providers/Firebase';

export const demoStorage = () => storage.ref('videos_demo')
